export default __webpack_public_path__ + "static/media/Water 8.a9e2c636.pdf";